module.exports = __webpack_public_path__ + "media/images/hero_images/security-400-e265fd2e2962051bbb651ef50263ae76.jpg";